import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://njhehxzagdbenkmyewbn.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5qaGVoeHphZ2RiZW5rbXlld2JuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc2ODA4MTAsImV4cCI6MjA4MzI1NjgxMH0.gWRGWLzy9g4dwdx2o8RTJair0OfL9hIgsb7b1-RRMoQ';

console.log('✅ Supabase client initialized');

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});